import classnames from 'classnames';
import { COLORS } from 'Components/utils/color/colors';

export const themes = {
  default: ({ titleColor, subtitleColor, isHover }) => ({
    thRoot: 'bg-gray-darker image-responsive-cell relative overflow-hidden rounded-tiny',
    thImage: classnames('transition-transform-opacity opacity-75', { 'scale-105': isHover }),
    thHeader: 'absolute top-0 mt-5 w-full text-center flex justify-center',
    thHeaderItem: ({ textColor = COLORS.WHITE, backgroundColor = COLORS.BLACK }) =>
      classnames('p-2 m-0 mx-1 rounded-tiny max-w-1/2 font-brand text-xs leading-one font-normal', {
        [`text-${textColor}`]: true,
        [`bg-${backgroundColor}`]: true,
      }),
    thTitle: classnames('reset-heading mb-3 font-bold leading-tight text-2xl text-center', {
      [`text-${titleColor || COLORS.WHITE}`]: true,
    }),
    thSubTitle: classnames('m-0 pb-4 text-md text-center', {
      [`text-${subtitleColor || COLORS.WHITE}`]: true,
    }),
    thFooter: 'absolute p-2 pb-6 bottom-0 w-full transition-transform',
  }),
};
